define.alias("shared/components/shared/linkinbio/list/multi-link", "settings/components/shared/linkinbio/list/multi-link");